import script from "./repair-order-duty-result.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-order-duty-result.vue?vue&type=script&lang=ts&setup=true"

import "./repair-order-duty-result.vue?vue&type=style&index=0&id=c00a45fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00a45fa"]])

export default __exports__